/*
1	Buddy Rogers	4/25/1963
2	Bruno Sammartino	5/17/1963
3	Ivan Koloff	1/18/1971
4	Pedro Morales	2/8/1971
5	Stan Stasiak	12/1/1973
6	Bruno Sammartino	12/10/1973
7	Superstar Billy Graham	4/30/1977
8	Bob Backlund	2/20/1978
9	The Iron Sheik	12/26/1983
10	Hulk Hogan	1/23/1984
11	André the Giant	2/5/1988
12	Randy Savage	3/27/1988
13	Hulk Hogan	4/2/1989
14	The Ultimate Warrior	4/1/1990
15	Sgt. Slaughter	1/19/1991
16	Hulk Hogan	3/24/1991
17	The Undertaker	11/27/1991
18	Hulk Hogan	12/3/1991
—	Vacated	12/7/1991
19	Ric Flair	1/19/1992
20	Randy Savage	4/5/1992
21	Ric Flair	9/1/1992
22	Bret Hart	10/12/1992
23	Yokozuna	4/4/1993
24	Hulk Hogan	4/4/1993
25	Yokozuna	6/13/1993
26	Bret Hart	3/20/1994
27	Bob Backlund	11/23/1994
28	Diesel	11/26/1994
29	Bret Hart	11/19/1995
30	Shawn Michaels	3/31/1996
31	Sycho Sid	11/17/1996
32	Shawn Michaels	1/19/1997
—	Vacated	2/13/1997
33	Bret Hart	2/16/1997
34	Sycho Sid	2/17/1997
35	The Undertaker	3/23/1997
36	Bret Hart	8/3/1997
37	Shawn Michaels	11/9/1997
38	"Stone Cold" Steve Austin	3/29/1998
39	Kane	6/28/1998
40	"Stone Cold" Steve Austin	6/29/1998
—	Vacated	9/27/1998
41	The Rock	11/15/1998
42	Mankind	1/4/1999
43	The Rock	1/24/1999
44	Mankind	1/31/1999
45	The Rock	2/15/1999
46	"Stone Cold" Steve Austin	3/28/1999
47	The Undertaker	5/23/1999
48	"Stone Cold" Steve Austin	6/28/1999
49	Mankind	8/22/1999
50	Triple H	8/23/1999
51	Vince McMahon	9/16/1999
—	Vacated	9/20/1999
52	Triple H	9/26/1999
53	Big Show	11/14/1999
54	Triple H	1/3/2000
55	The Rock	4/30/2000
56	Triple H	5/21/2000
57	The Rock	6/25/2000
58	Kurt Angle	10/22/2000
59	The Rock	2/25/2001
60	"Stone Cold" Steve Austin	4/1/2001
61	Kurt Angle	9/23/2001
62	"Stone Cold" Steve Austin	10/8/2001
63	Chris Jericho	12/9/2001
64	Triple H	3/17/2002
65	Hollywood Hulk Hogan	4/21/2002
66	The Undertaker	5/19/2002
67	The Rock	7/21/2002
68	Brock Lesnar	8/25/2002
69	Big Show	11/17/2002
70	Kurt Angle	12/15/2002
71	Brock Lesnar	3/30/2003
72	Kurt Angle	7/27/2003
73	Brock Lesnar	9/18/2003
74	Eddie Guerrero	2/15/2004
75	John Bradshaw Layfield	6/27/2004
76	John Cena	4/3/2005
77	Edge	1/8/2006
78	John Cena	1/29/2006
79	Rob Van Dam	6/11/2006
80	Edge	7/3/2006
81	John Cena	9/17/2006
—	Vacated	10/2/2007
82	Randy Orton	10/7/2007
83	Triple H	10/7/2007
84	Randy Orton	10/7/2007
85	Triple H	4/27/2008
86	Edge	11/23/2008
87	Jeff Hardy	12/14/2008
88	Edge	1/25/2009
89	Triple H	2/15/2009
90	Randy Orton	4/26/2009
91	Batista	6/7/2009
—	Vacated	6/9/2009
92	Randy Orton	6/15/2009
93	John Cena	9/13/2009
94	Randy Orton	10/4/2009
95	John Cena	10/25/2009
96	Sheamus	12/13/2009
97	John Cena	2/21/2010
98	Batista	2/21/2010
99	John Cena	3/28/2010
100	Sheamus	6/20/2010
101	Randy Orton	9/19/2010
102	The Miz	11/22/2010
103	John Cena	5/1/2011
104	CM Punk	7/17/2011
—	Vacated	7/18/2011
105	Rey Mysterio	7/25/2011
106	John Cena	7/25/2011
—	CM Punk	8/14/2011
107	Alberto Del Rio	8/14/2011
108	John Cena	9/18/2011
109	Alberto Del Rio	10/2/2011
110	CM Punk	11/20/2011
111	The Rock	1/27/2013
112	John Cena	4/7/2013
113	Daniel Bryan	8/18/2013
114	Randy Orton	8/18/2013
115	Daniel Bryan	9/15/2013
—	Vacated	9/16/2013
116	Randy Orton	10/27/2013
117	Daniel Bryan	4/6/2014
—	Vacated	6/9/2014
118	John Cena	6/29/2014
119	Brock Lesnar	8/17/2014
120	Seth Rollins	3/29/2015
—	Vacated	11/4/2015
121	Roman Reigns	11/22/2015
122	Sheamus	11/22/2015
123	Roman Reigns	12/14/2015
124	Triple H	1/24/2016
125	Roman Reigns	4/3/2016
126	Seth Rollins	6/19/2016
127	Dean Ambrose	6/19/2016
128	AJ Styles	9/11/2016
129	John Cena	1/29/2017
130	Bray Wyatt	2/12/2017
131	Randy Orton	4/2/2017
132	Jinder Mahal	5/21/2017
133	AJ Styles	11/7/2017
134	Daniel Bryan	11/13/2018
135	Kofi Kingston	4/7/2019
136	Brock Lesnar	10/4/2019
137	Drew McIntyre	3/26/2020
138	Randy Orton	10/25/2020
139	Drew McIntyre	11/16/2020
140	The Miz	2/21/2021
141	Bobby Lashley	3/1/2021
142	Big E	9/13/2021
143	Brock Lesnar	1/1/2022
144	Bobby Lashley	1/29/2022
145	Brock Lesnar	2/19/2022
146	Roman Reigns	4/3/2022
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const championshipId = "wwe-title";
const _default = [
    {
        id: "start-story",
        name: "Acknowledge Him",
        wrestlerIds: [
            "cody-rhodes"
        ],
        championshipId,
        defenses: 0,
        startDate: new Date("Apr 7, 2024")
    },
    {
        id: "acknowledge-him-we",
        name: "Acknowledge Him",
        wrestlerIds: [
            "roman-reigns"
        ],
        championshipId,
        defenses: 25,
        startDate: new Date("Apr 3, 2022"),
        endDate: new Date("Apr 7, 2024")
    },
    {
        id: "wwe-title-01",
        wrestlerIds: [
            "brock-lesnar"
        ],
        championshipId,
        startDate: new Date("Feb 19, 2022"),
        endDate: new Date("Apr 3, 2022")
    },
    {
        id: "wwe-title-02",
        wrestlerIds: [
            "bobby-lashley"
        ],
        championshipId,
        startDate: new Date("Jan 29, 2022"),
        endDate: new Date("Feb 19, 2022")
    },
    {
        id: "wwe-title-03",
        wrestlerIds: [
            "brock-lesnar"
        ],
        championshipId,
        startDate: new Date("Jan 1, 2022"),
        endDate: new Date("Jan 29, 2022")
    },
    {
        id: "wwe-title-04",
        wrestlerIds: [
            "big-e"
        ],
        championshipId,
        startDate: new Date("Sep 13, 2021"),
        endDate: new Date("Jan 1, 2022")
    },
    {
        id: "wwe-title-05",
        wrestlerIds: [
            "bobby-lashley"
        ],
        championshipId,
        startDate: new Date("Mar 1, 2021"),
        endDate: new Date("Sep 13, 2021")
    },
    {
        id: "wwe-title-06",
        wrestlerIds: [
            "the-miz"
        ],
        championshipId,
        startDate: new Date("Feb 21, 2021"),
        endDate: new Date("Mar 1, 2021")
    },
    {
        id: "wwe-title-07",
        wrestlerIds: [
            "drew-mcintyre"
        ],
        championshipId,
        startDate: new Date("Nov 16, 2020"),
        endDate: new Date("Feb 21, 2021")
    },
    {
        id: "wwe-title-08",
        wrestlerIds: [
            "randy-orton"
        ],
        championshipId,
        startDate: new Date("Oct 4, 2020"),
        endDate: new Date("Nov 16, 2020")
    },
    {
        id: "wwe-title-09",
        wrestlerIds: [
            "drew-mcintyre"
        ],
        championshipId,
        startDate: new Date("Apr 5, 2020"),
        endDate: new Date("Oct 25, 2020")
    },
    {
        id: "wwe-title-10",
        wrestlerIds: [
            "brock-lesnar"
        ],
        championshipId,
        startDate: new Date("Oct 4, 2019"),
        endDate: new Date("Apr 5, 2020")
    },
    {
        id: "wwe-title-11",
        wrestlerIds: [
            "kofi-kingston"
        ],
        championshipId,
        startDate: new Date("Apr 7, 2019"),
        endDate: new Date("Oct 4, 2019")
    },
    {
        id: "wwe-title-12",
        wrestlerIds: [
            "daniel-bryan"
        ],
        championshipId,
        startDate: new Date("Nov 13, 2018"),
        endDate: new Date("Apr 7, 2019")
    },
    {
        id: "wwe-title-13",
        wrestlerIds: [
            "aj-styles"
        ],
        championshipId,
        startDate: new Date("Nov 7, 2017"),
        endDate: new Date("Nov 13, 2018")
    },
    {
        id: "wwe-title-14",
        wrestlerIds: [
            "jinder-mahal"
        ],
        championshipId,
        startDate: new Date("May 21, 2017"),
        endDate: new Date("Nov 7, 2017")
    },
    {
        id: "wwe-title-15",
        wrestlerIds: [
            "randy-orton"
        ],
        championshipId,
        startDate: new Date("Apr 2, 2017"),
        endDate: new Date("May 21, 2017")
    },
    {
        id: "wwe-title-16",
        wrestlerIds: [
            "bray-wyatt"
        ],
        championshipId,
        startDate: new Date("Feb 12, 2017"),
        endDate: new Date("Apr 2, 2017")
    },
    {
        id: "wwe-title-17",
        wrestlerIds: [
            "john-cena"
        ],
        championshipId,
        startDate: new Date("Jan 29, 2017"),
        endDate: new Date("Feb 12, 2017")
    },
    {
        id: "wwe-title-18",
        wrestlerIds: [
            "aj-styles"
        ],
        championshipId,
        startDate: new Date("Sep 11, 2016"),
        endDate: new Date("Jan 29, 2017")
    },
    {
        id: "wwe-title-19",
        wrestlerIds: [
            "dean-ambrose"
        ],
        championshipId,
        startDate: new Date("Jun 19, 2016"),
        endDate: new Date("Sep 11, 2016")
    },
    {
        id: "wwe-title-20",
        wrestlerIds: [
            "seth-rollins"
        ],
        championshipId,
        startDate: new Date("Jun 19, 2016"),
        endDate: new Date("Jun 19, 2016")
    },
    {
        id: "wwe-title-21",
        wrestlerIds: [
            "roman-reigns"
        ],
        championshipId,
        startDate: new Date("Apr 3, 2016"),
        endDate: new Date("Jun 19, 2016")
    },
    {
        id: "wwe-title-22",
        wrestlerIds: [
            "triple-h"
        ],
        championshipId,
        startDate: new Date("Jan 24, 2016"),
        endDate: new Date("Apr 3, 2016")
    },
    {
        id: "wwe-title-23",
        wrestlerIds: [
            "roman-reigns"
        ],
        championshipId,
        startDate: new Date("Nov 22, 2015"),
        endDate: new Date("Jan 24, 2016")
    },
    {
        id: "wwe-title-24",
        wrestlerIds: [
            "sheamus"
        ],
        championshipId,
        startDate: new Date("Nov 22, 2015"),
        endDate: new Date("Nov 22, 2015")
    },
    {
        id: "wwe-title-25",
        wrestlerIds: [
            "roman-reigns"
        ],
        championshipId,
        startDate: new Date("Nov 22, 2015"),
        endDate: new Date("Nov 22, 2015")
    },
    {
        id: "wwe-title-26",
        wrestlerIds: [
            "seth-rollins"
        ],
        championshipId,
        startDate: new Date("Mar 29, 2015"),
        endDate: new Date("Nov 22, 2015")
    },
    {
        id: "wwe-title-27",
        wrestlerIds: [
            "brock-lesnar"
        ],
        championshipId,
        startDate: new Date("Aug 17, 2014"),
        endDate: new Date("Mar 29, 2015")
    },
    {
        id: "wwe-title-28",
        wrestlerIds: [
            "john-cena"
        ],
        championshipId,
        startDate: new Date("Jun 29, 2014"),
        endDate: new Date("Aug 17, 2014")
    },
    {
        id: "wwe-title-29",
        wrestlerIds: [
            "randy-orton"
        ],
        championshipId,
        startDate: new Date("Jun 29, 2014"),
        endDate: new Date("Jun 29, 2014")
    },
    {
        id: "wwe-title-30",
        wrestlerIds: [
            "daniel-bryan"
        ],
        championshipId,
        startDate: new Date("Aug 18, 2013"),
        endDate: new Date("Jun 29, 2014")
    },
    {
        id: "wwe-title-31",
        wrestlerIds: [
            "randy-orton"
        ],
        championshipId,
        startDate: new Date("Apr 7, 2013"),
        endDate: new Date("Aug 18, 2013")
    },
    {
        id: "wwe-title-32",
        wrestlerIds: [
            "the-rock"
        ],
        championshipId,
        startDate: new Date("Jan 27, 2013"),
        endDate: new Date("Apr 7, 2013")
    },
    {
        id: "wwe-title-33",
        wrestlerIds: [
            "cm-punk"
        ],
        championshipId,
        startDate: new Date("Nov 20, 2011"),
        endDate: new Date("Jan 27, 2013")
    }
];
